import './App.css';
import Home from './Pages/Home/Home';
import Roadmap from './Pages/Roadmaps/Roadmap';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/roadmap' element={<Roadmap />}/>
      </Routes>

    </Router>

  );
}

export default App;
